import { mergeManualGlass, metZusterFotos, type Product } from "@glastotaal/core";
import productsJson from "../../../data/seed/products.json";
import articlesJson from "../../../data/seed/articles.json";
import type { Article } from "./index";

/**
 * De zware catalogus-seed (products + articles, samen ~1,8 MB bron) in een eigen,
 * DYNAMISCH geïmporteerd module. Voorheen zat dit statisch in de entry-modulegraaf en
 * werd het — parse + mergeManualGlass — uitgevoerd in dezelfde lange opstart-taak als
 * de rest van de app (de grootste Total Blocking Time-post na de render zelf).
 * Nu laadt `loadCatalogData()` (index.ts) dit bestand async vóór de eerste render;
 * de prerender-HTML blijft intussen zichtbaar. Type-only import van `Article` is
 * cirkelvrij (wordt bij compilatie gewist).
 */
export const products: Product[] = mergeManualGlass(productsJson as unknown as Product[]);
/**
 * Artikelen zonder eigen foto lenen het beeld van een artikel uit dezelfde serie (zusterFoto,
 * core/articles/zusterfoto.ts). 114 artikelen — vooral maatvarianten van diamantboren — hebben
 * geen foto-URL van Timmers; zonder beeld vallen ze uit de Merchant Center-feed en oogt de
 * categoriepagina rommelig. De feed doet hetzelfde in scripts/generate-product-feed.mjs.
 */
export const articles: Article[] = metZusterFotos(articlesJson as unknown as Article[]);
